import type { Country } from './localData';

export type LabInstitutionSource = {
  country?: Country;
  labName?: string;
};

function comparableName(value: string): string {
  return value.normalize('NFKC').trim().replace(/\s+/g, ' ').toLocaleLowerCase();
}

// This is intentionally a picker, not an automatic alias resolver. A name in
// Hebrew and its English transliteration may be the same institution, but the
// application must not silently decide that for the family. The person selects
// the established account spelling when reviewing the document.
export function knownLabInstitutions(
  sources: LabInstitutionSource[],
  country: Country | '',
): string[] {
  if (!country) return [];
  const names = new Map<string, string>();
  for (const source of sources) {
    if (source.country !== country || !source.labName?.trim()) continue;
    const name = source.labName.trim().replace(/\s+/g, ' ');
    const key = comparableName(name);
    if (!names.has(key)) names.set(key, name);
  }
  return [...names.values()].sort((left, right) => left.localeCompare(right, 'ru'));
}
